import { render, staticRenderFns } from "./src/components/test.html?vue&type=template&id=6d6049f6&"
import script from "./src/components/test.js?vue&type=script&lang=js&"
export * from "./src/components/test.js?vue&type=script&lang=js&"
import style0 from "./src/components/test.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports